import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title: string;
    description?: string;
    image?: string;
    url?: string;
    type?: 'website' | 'article';
    schema?: Record<string, any>;
}

const SEO = ({
    title,
    description = "Maximum Productions — Animation studio. Currently in production on ETERNITY, a cyberpunk short film about immortality and loss. Coming 2028.",
    image = "/og-image.png",
    url = typeof window !== 'undefined' ? window.location.href : '',
    type = 'website',
    schema
}: SEOProps) => {
    const siteTitle = "Maximum Productions";
    const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;
    // Crawlers require absolute og:image URLs; keep helmet consistent with the
    // server-injected tags from the Pages Functions.
    const absoluteImage = image.startsWith('http')
        ? image
        : `${typeof window !== 'undefined' ? window.location.origin : 'https://thisismaximum.com'}${image}`;

    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {/* Open Graph tags */}
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={absoluteImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={siteTitle} />

            {/* Twitter Card tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={absoluteImage} />

            {/* Structured Data */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
